module.exports = "<div id=\"loading\" class=\"loading-banner\" style=\"display:block\">\n    <span rel=\"localize[loading-msg]\">Please wait ...</span>\n</div>"